import { format, toZonedTime } from "date-fns-tz";
 /**
   * Sentinel one API returns the UTC date
   * For the end user we have to calculate the right time depending on where they are located
   */
export function timeZone(){
    const getTimeZone = (): string => {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    };

    const adjustTimeToTimeZone = (isoDate: string, timeZone: string): string => {
        const zonedTime = toZonedTime(isoDate, timeZone);
        return format(zonedTime, "yyyy-MM-dd'T'HH:mm:ss", { timeZone });
    };

    return { getTimeZone, adjustTimeToTimeZone }
}